export interface Bonus {
  n: string
  title: string
  description: string
  /** Estimated reference value in USD; shown converted to the visitor's currency. */
  valueUsd: number
  image: string
  /** Pastel plate behind the cut-out mockup, matched to the book cover. */
  bg: string
  /** Bonuses with extra visual weight in the grid. */
  featured?: boolean
}

export const bonuses: Bonus[] = [
  {
    n: '01',
    title: 'Planificador semanal',
    description: 'Organiza las actividades de toda la semana.',
    valueUsd: 2.99,
    bg: '#EFEAFB',
    image:
      'https://cdn.magicpatterns.com/uploads/v51Mrvt2khwdmi4NQR5pYo/hf_20260801_002457_01e6fcda-0f57-4a8e-a463-cc89a45e30aa.png',
  },
  {
    n: '02',
    title: 'Diario creativo del niño',
    description: 'Un espacio para registrar ideas, dibujos y actividades favoritas.',
    valueUsd: 3.99,
    bg: '#FDEAEC',
    image:
      'https://cdn.magicpatterns.com/uploads/44Z9ER8KzSVpmiKbNKhX4t/hf_20260801_002556_3a9b1b98-ba62-4305-8257-5a920fab0960.png',
  },
  {
    n: '03',
    title: 'Certificado de gran creador',
    description: 'Reconocimiento imprimible para celebrar sus logros.',
    valueUsd: 1.99,
    bg: '#FDEEE0',
    image:
      'https://cdn.magicpatterns.com/uploads/ewG12YmSthcmsD6bFjqktf/hf_20260801_002713_f3a11211-6fa1-4eee-a1ae-254bf0eaa80d.png',
  },
  {
    n: '04',
    title: 'Seguridad en casa',
    description:
      'Recomendaciones prácticas para preparar un espacio de actividades más seguro.',
    valueUsd: 4.99,
    bg: '#E7F6EC',
    image:
      'https://cdn.magicpatterns.com/uploads/bteE5KyQavYnrLR7AU1Htw/hf_20260801_002754_bc07c455-dd68-47d2-9c5d-cccd0984755a.png',
    featured: true,
  },
  {
    n: '05',
    title: 'Días de lluvia',
    description: 'Actividades adicionales para quedarse en casa.',
    valueUsd: 4.99,
    bg: '#E6F2FB',
    image:
      'https://cdn.magicpatterns.com/uploads/dAKPE7Bo9ukEQi4Ex8kKCQ/hf_20260801_002830_aa68466e-d0c2-486d-9eb9-bbb460e5b8ff.png',
    featured: true,
  },
  {
    n: '06',
    title: 'Rincón creativo',
    description: 'Ideas para preparar un pequeño espacio creativo.',
    valueUsd: 3.49,
    bg: '#EFEAFB',
    image:
      'https://cdn.magicpatterns.com/uploads/eVbRLW23H49po5aCPN5Y8D/hf_20260801_002901_9074c5af-85e2-47bc-aeab-e648690f1dcc.png',
  },
  {
    n: '07',
    title: 'Materiales en orden',
    description: 'Sistema sencillo para organizar materiales.',
    valueUsd: 2.99,
    bg: '#E9F6EE',
    image:
      'https://cdn.magicpatterns.com/uploads/w8xca75r24baa5qC8tJtYS/hf_20260801_002932_4ca77426-a023-40c8-9a82-ebcb8a38582d.png',
  },
  {
    n: '08',
    title: 'Autonomía creativa',
    description: 'Ideas para que el niño participe en preparar, crear y recoger.',
    valueUsd: 4.99,
    bg: '#FDEAEC',
    image:
      'https://cdn.magicpatterns.com/uploads/9Wd73kmr8hY94Pyf7cHETR/hf_20260801_003044_946f24ad-fee0-49c4-a3d1-f298008aacbc.png',
    featured: true,
  },
  {
    n: '09',
    title: 'Cuentos para despertar la imaginación',
    description: 'Historias acompañadas de retos creativos.',
    valueUsd: 5.99,
    bg: '#E6F2FB',
    image:
      'https://cdn.magicpatterns.com/uploads/3gMgAB88yGGvWrUyqTTFxz/hf_20260801_211813_2220e143-9f25-4970-9a15-dcada34a4d1f.png',
    featured: true,
  },
  {
    n: '10',
    title: 'Lunches fáciles',
    description: 'Ideas prácticas para escuela, paseos y días ocupados.',
    valueUsd: 4.99,
    bg: '#FDEFE2',
    image:
      'https://cdn.magicpatterns.com/uploads/jvnR6UbbcpaH3h2WxK8Nsk/hf_20260801_003117_963584f9-4f55-45fb-8296-a6f6a420cdf2.png',
  },
]

/** Estimated reference values in USD, converted on screen to the local currency. */
export const EBOOK_VALUE_USD = 33.99
export const PASSPORT_VALUE_USD = 3.99
export const BONUSES_VALUE_USD = bonuses.reduce((sum, b) => sum + b.valueUsd, 0)
export const PACK_VALUE_USD = EBOOK_VALUE_USD + BONUSES_VALUE_USD + PASSPORT_VALUE_USD

export const images = {
  /** Full bundle: main ebook surrounded by the 10 bonus books. */
  bundle:
    'https://cdn.magicpatterns.com/uploads/2JGBhn6diPy9Gt3SKi2veJ/ChatGPT_Image_2_ago_2026,_03_56_22_p.m..png',
  /** Clean main ebook cover mockup (white studio background, used as a cut-out). */
  mainBook:
    'https://cdn.magicpatterns.com/uploads/idx1sM2fcESnJdFM6Yt9o4/hf_20260801_003457_1395a656-82d2-4caf-96ae-e1776cb29ddb.png',
  passport:
    'https://cdn.magicpatterns.com/uploads/az3kKrWf8Xb3pAEm9e2Zo3/hf_20260801_003157_9234be16-1461-4211-bbbd-c45a81e5a359.png',
}


